export default __webpack_public_path__ + "images/ebca2ac2676d6138ecf25a7554eab401-science.webp";